import { gql } from '@apollo/client';

export const ALL_INSTITUTIONS = gql`
  query AllInstitutions($input: FilterInstitutions!) {
    institutions: getInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          emisNumber
          trackingCode
          isArchived
          ministry {
            id
            name
          }

          #relationship
          district {
            id
            name
          }
          duplicateAction
          duplicateReference
          wardID
          wardLabel
          name
          localMunicipality {
            id
            localMunicipalityShorthand
          }
          districtMunicipality {
            id
            name
          }
          reasonForDuplicateAction
          province {
            id
            name
          }
          interventions {
            id
          }
          stakeholdersCount
          type {
            id
            name
          }
          users {
            id
          }
        }
      }
    }
  }
`;
